/**
 * @deprecated TODO a priori ?
 * @returns {{loading: boolean, readonly code: (*|undefined), readonly isCodeValid: (boolean|*)}|*|boolean}
 */
export default function lookupOrganization() {
    return {
        loading: false,

        get code() {
            if (this.store){
                console.log('reading from store');
                return this.store.getField('organizationCode')
            }
        },

        get isCodeValid() {
            if (!this.code) return false

            const clean = this.code.replace(/\s/g, '')

            return (
                /^[0-9]{9}$/.test(clean) ||     // SIREN
                /^[0-9]{14}$/.test(clean) // ||    // SIRET
              //  /^[0-9A-Z]{8}$/.test(clean)     // UAI désactivé temporairement
            )
        },

    }
}
